export default __webpack_public_path__ + "static/media/boelterLogo.55ceca8b.webp";